import type { ReactNode } from 'react';
import { Scene } from '../art/Scene';
import { themeVars, useTheme } from '../theme/theme';
import type { ScreenName } from './Screen';

/**
 * Sign-in on a tablet or desktop: the animated Trikuta & Chenab scene as a hero (left, or on top of a portrait
 * tablet) and the step itself in a card beside it — a designed split hero, not a stretched phone.
 */
export function AuthHero({ name, label, children }: { name: ScreenName; label: string; children: ReactNode }) {
  const { mode } = useTheme();
  return (
    <main className="zr-auth" data-screen={name} data-theme={mode} aria-label={label} style={themeVars(mode, 'base')}>
      <div className="zr-auth-hero">
        <Scene />
      </div>
      <div className="zr-auth-side">
        <div className="zr-auth-card">{children}</div>
      </div>
    </main>
  );
}
